import { Component, OnInit, ViewChild, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IgxDropDownComponent, IgxInputGroupComponent, IgxInputDirective, ISelectionEventArgs } from 'igniteui-angular';
import { GenericSelectorItem } from '../../models/componentInterfaces';
import { GenericService } from '../../services/generic.service';

@Component({
  selector: 'app-generic-selector',
  templateUrl: './generic-selector.component.html',
  styleUrls: ['./generic-selector.component.scss']
})
export class GenericSelectorComponent implements OnInit {

  ComboPlaceHolder: string = "";
  items: GenericSelectorItem[] = [];
  selectorForm: FormGroup;
  public loading = false;
  selectedItem: string;
  public selectedValue: GenericSelectorItem;

  @ViewChild(IgxDropDownComponent)
  public igxDropDown: IgxDropDownComponent;

  @ViewChild("inputGroup", { read: IgxInputGroupComponent })
  public inputGroup: IgxInputGroupComponent;

  @ViewChild("input", { read: IgxInputDirective })
  public input: IgxInputDirective;

  @Output()
  onItemSelected: EventEmitter<GenericSelectorItem> = new EventEmitter<GenericSelectorItem>();


  constructor(private fb: FormBuilder,
    private genericService: GenericService) { }

  ngOnInit() {
    this.initForm();
  }

  setDaysOfTheWeek() {
    this.items = this.genericService.getDaysOfTheWeek();
  }

  initForm() {
    this.selectorForm = this.fb.group({
      ComboValue: [null, [Validators.required, Validators.minLength(1)]],
    });
  }

  public onSelection(eventArgs: ISelectionEventArgs) {
    this.selectedValue = this.items.find(item => item.Id == eventArgs.newSelection.value);
    this.selectedItem = this.selectedValue.Name;
    this.selectorForm.get('ComboValue').setValue(this.selectedItem);
    this.onItemSelected.emit(this.selectedValue);
  }

  public setComboById(id: number | string) {
    if (this.items && this.items.length > 0 && id !== null) {
      this.selectedValue = this.items.find(item => item.Id == id);
      this.selectedItem = this.selectedValue.Name;
      this.selectorForm.get('ComboValue').setValue(this.selectedItem);
    }
  }

  public getItemInfo(): string {
    if (this.selectedValue) {
      this.selectedItem = this.selectedValue.Name;
      return this.selectedItem;
    }
    return null;
  }

  public getItemId(): number | string{
    if (this.selectedValue)
      return this.selectedValue.Id;

    return null;
  }

  resetForm() {
    this.initForm();
    this.selectedValue = null;
    this.selectedItem = null;
  }

  openDropDown() {

  }


}
